import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
var families = {
  CUSTOM: 'custom',
  SYSTEM: 'system',
  BLOKK: 'blokk'
};
families.ALL = _valuesInstanceProperty(_).call(_, families);
var weights = {
  LIGHT: 'light',
  REGULAR: 'regular',
  MEDIUM: 'medium'
};
weights.ALL = _valuesInstanceProperty(_).call(_, weights);
var emphasis = {
  CAPS: 'caps',
  NORMAL: 'normal'
};
emphasis.ALL = _valuesInstanceProperty(_).call(_, emphasis);
var font = {
  families: families,
  weights: weights,
  emphasis: emphasis
};
export default font;
//# sourceMappingURL=font.js.map